import t from "../../theme";

export const useGetContentCardStyles = () => {
  return {
    card: {
      position: "relative",
      background: t.glass.primary,
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      borderRadius: t.radius.lg,
      border: t.border.base,
      boxShadow: t.shadow.lg,
      overflow: "hidden",
    },
    accent: {
      height: "4px",
      width: "100%",
      background: t.green.gradient,
      flexShrink: 0,
    },
    body: {
      padding: "32px",
    },
    bodyFlush: {},
  };
};
